import { Component, OnInit, input } from "@angular/core";

@Component({
  selector: "av-card-row-column",
  templateUrl: "./card-row-column.component.html",
  styleUrls: ["./card-row-column.component.scss"],
  standalone: false,
})
export class CardRowColumnComponent implements OnInit {
  readonly label = input<string>(undefined);
  readonly value = input<string>(undefined);
  readonly tooltip = input<string>(undefined);

  constructor() {}

  ngOnInit(): void {}
}
